import { Component, OnInit } from '@angular/core';
import {Ship} from "../../Ship";
import {EntitlementService} from "../../services/entitlement.service";
import {ShipService} from "../../services/ship.service";
import {Router} from "@angular/router";
import {MessageService} from "../../services/message.service";
import {ShipLog} from "./ShipLog";
import { HeaderService } from '../../services/header.service';


@Component({
  selector: 'app-ship-logs',
  templateUrl: './ship-logs.component.html',
  styleUrls: ['./ship-logs.component.css']
})
export class ShipLogsComponent implements OnInit {
  ship: Ship;
  shipResultArray: Ship[];
  shipLogsArray: ShipLog[];

  constructor(private entitlementService: EntitlementService,
              private shipService: ShipService,
              private router: Router,
              private messageService: MessageService,
              private headerService: HeaderService
  ) { }

  ngOnInit() {
    this.ship = this.shipService.retrieveShipProfile();
    this.shipResultArray = this.shipService.retieveAllShipProfileResults();
    if (this.ship == null) {
      this.router.navigate(['/shipProfiles']);
    }
    this.getLogs();
  }

  onShipChange(newShip: Ship) {
    this.ship = newShip;
    this.getLogs();
  }

  hasEntitlement(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  getLogs() {
    this.shipService.getLogsByShip(this.ship.shipLocation).subscribe(
      (data: ShipLog[]) => {
        this.shipLogsArray = data;
      },
      error => {
        console.log('Error retrieving ship logs ', error.error.message);
      }
    );
  }

  goToLogDetails(log: ShipLog) {
    const downloadButton = document.getElementById(log.uuid);
    downloadButton.textContent = 'downloading...';
    let url = this.shipService.downloadShipLog(log.uuid);
    fetch(url, {  method: 'GET',
                  headers: {
                    'Content-Type': this.headerService.getXAuthHeaderFromCookie().get('Content-type'),
                    'Authorization': this.headerService.getXAuthHeaderFromCookie().get('Authorization'),
                    'Registration': this.headerService.getXAuthHeaderFromCookie().get('Registration')
                  }
    } ) // FETCH BLOB FROM IT
      .then((response) => response.blob())
      .then((blob) => { // RETRIEVE THE BLOB AND CREATE LOCAL URL
        const downloadUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = log.deviceId + '-' + log.uuid;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(downloadUrl);
    }).catch((err) => {
      console.log(err);
    })
    .finally(() => {
      downloadButton.textContent = 'download';
    });
  }
}
